import { CheckCircle, FileText, Printer, Undo2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/context/LanguageContext";
import { groupByLabelFile } from "@/lib/boxing";

// One row per label file under a store's boxes: which boxes it covers, print it, confirm the boxes are done.
export default function LabelFileRows({ boxes, labels }) {
  const { t } = useLang();
  const files = groupByLabelFile(boxes);
  if (files.length === 0) return null;

  return (
    <div className="grid gap-2 px-4 pb-4" data-testid="label-files">
      <h3 className="text-sm font-bold text-slate-800">{t("labels.files_title")}</h3>
      {files.map(file => {
        const done = file.boxes.every(b => b.label_state === "APPLIED");
        return (
          <div key={file.url} data-testid="label-file-row"
            className={`flex flex-wrap items-center gap-x-3 gap-y-2 rounded-xl border px-3 py-2 ${done ? "border-emerald-200 bg-emerald-50/60" : "border-slate-200 bg-white"}`}>
            <FileText className={`h-4 w-4 shrink-0 ${done ? "text-emerald-600" : "text-slate-400"}`} />
            <div className="flex min-w-40 flex-1 flex-wrap items-center gap-1.5">
              {file.boxes.map(box => (
                <span key={box.id} className="rounded-md bg-slate-100 px-1.5 py-0.5 text-xs font-bold text-slate-700">{box.box_name}</span>
              ))}
            </div>
            <Button type="button" variant="outline" size="sm" className="h-7 max-w-56 gap-1.5 text-xs" onClick={() => labels.open(file.url)}
              title={file.name} data-testid="print-label-file">
              <Printer className="h-3.5 w-3.5 shrink-0" /> <span className="truncate">{file.name || t("labels.files_title")}</span>
            </Button>
            {labels.canAct && (done ? (
              <Button type="button" variant="ghost" size="sm" className="h-7 gap-1 text-xs" disabled={labels.busy}
                onClick={() => labels.undoApplied(file.boxes)} data-testid="undo-label-file">
                <CheckCircle className="h-3.5 w-3.5 text-emerald-600" /> {t("labels.done")} <Undo2 className="h-3 w-3" /> {t("labels.undo_applied")}
              </Button>
            ) : (
              <Button type="button" size="sm" className="h-7 gap-1 bg-emerald-600 text-xs hover:bg-emerald-700" disabled={labels.busy}
                onClick={() => labels.requestApplied(file.boxes)} data-testid="apply-label-file">
                <CheckCircle className="h-3.5 w-3.5" /> {t("labels.mark_done")}
              </Button>
            ))}
            {!labels.canAct && done && (
              <span className="inline-flex items-center gap-1 text-xs font-bold text-emerald-700">
                <CheckCircle className="h-3.5 w-3.5" /> {t("labels.done")}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
